import { StandardEntity } from '@infodata-group/inf-commons';
import { SerializedAlarmInterface } from '../../interface/serialized/serialized-alarm.interface';

export class Alarm extends StandardEntity {
  type: string;
  lib: string;
  heure: string;
  status: string;
  latitude: number;
  longitude: number;
  com: string[];
  map = 'Map';
  bbx: string;
  date: string;
  info: string;

  constructor() {
    super('', '', 'label');
  }

  public override getLabel(): string {
    return `${this.lib} ${this.bbx}`;
  }

  public override serialize(): SerializedAlarmInterface {
    return {
      id: this.id,
      type: this.type,
      heure: this.heure,
      status: this.status,
      latitude: this.latitude,
      longitude: this.longitude,
      lib: this.lib,
      com: this.com,
    };
  }
}
